import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import isShallowEqual from '@atlassian/jira-common-util-is-shallow-equal/src/index.tsx';
import type { Props } from './model/types.tsx';
import rootEpic from './ops/index.tsx';
import { initializeAppProps, getRelatedIssuesCount } from './state/actions.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class DeleteModal extends Component<Props> {
	constructor(props: Props) {
		super(props);
		this.store = createStore(rootEpic);
		this.store.dispatch(initializeAppProps(this.props));
		this.store.dispatch(getRelatedIssuesCount());
	}

	componentDidUpdate(prevProps: Props): void {
		if (isShallowEqual(prevProps, this.props)) {
			return;
		}
		this.store.dispatch(initializeAppProps(this.props));
	}

	store: Store<State>;

	render(): React.JSX.Element {
		return (
			<AppBase store={this.store}>
				<AppStyle>
					<View />
				</AppStyle>
			</AppBase>
		);
	}
}
